import { render, staticRenderFns } from "./SearchRecipes.vue?vue&type=template&id=611d7c22&scoped=true"
import script from "./SearchRecipes.vue?vue&type=script&lang=js"
export * from "./SearchRecipes.vue?vue&type=script&lang=js"
import style0 from "./SearchRecipes.vue?vue&type=style&index=0&id=611d7c22&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611d7c22",
  null
  
)

export default component.exports